import { API } from '../config/AppConfig';
import {
  ACCOUNTS_LIST,
  CREATE_DEPARTMENT,
  DEPARTMENT,
  EHR_LIST,
  GET_ACCOUNT,
  GET_ACCOUNT_DEPARTMENTS,
  GET_ACCOUNT_HOSPITALS,
  GET_ACCOUNT_MEMBERS,
  GET_ACCOUNT_TEAM_STATISTICS,
  GET_CLIENT_SPOC_LIST,
  GET_SPECIALTIES,
  HEALTH_SYSTEM_INFO,
  HOSPITAL_LIST,
  INSURANCE_LIST,
  DELETE_ACCOUNT,
  GET_PROVIDER_LIST,
  CREATE_PROVIDER,
  GET_PROVIDER_BY_DEPARTMENT,
  GET_PROVIDER,
  UPDATE_PROVIDER,
  DELETE_PROVIDER,
  ALL_DEPARTMENT,
  GET_DEPARTMENT_DROPDOWN,
  HOSPITAL,
  CREATE_HEALTH_SYSTEM,
  CREATE_HOSPITAL,
  GET_HOSPITAL_DATA,
  HEALTH_SYSTEM_VALIDATION,
  CQ_USERS_MAIL_ID,
  CQ_HOSPITAL_DATA,
  HOSPITAL_DEPARTMENTS,
  PHYSICIAN_LIST,
  MOODLE_ACTION,
  MOODLE_ACTION_MODIFY,
  MOODLE_SYNC_PROVIDER_BY_DEPARTMENT,
  GET_ALL_DEPARTMENTS_BY_HS,
  CMS_DATA_COUNT,
  SPEC_VISITS_PER_PROV_PERCENTILE,
  CMS_SPEC_COUNT,
  QUALIFICATION,
  QUALIFICATION_TO_CLIENT,
  HEALTH_SYSTEM_PERMANENT_DELETE,
  ACRHIVED_ACCOUNTS_LIST,
  RESTORE_ACCOUNT
} from '../constants/Endpoints';

class AccountsRepository {
  // constructor() {
  // this.ehrOptions = [...ehrOptions];
  // this.insuranceOptions = [...insuranceOptions];
  // this.specialtyOptions = [...specialtyOptions];
  // this.hospitals = [...hospitalData];

  // this.healthSystem = healthSystemInformation;
  // }

  async getAllDepartmentSByHS(healthSystemID) {
    const response = await API.get(GET_ALL_DEPARTMENTS_BY_HS, {
      pathParams: { healthSystemID },
    });
    return response;
  }

  async getHealthSystemInformation(healthSystemId) {
    const response = await API.get(HEALTH_SYSTEM_INFO, {
      pathParams: { healthSystemId },
    });
    return response;
  }

  async updateHealthSystemInformation(healthSystemId, payload) {
    const response = await API.put(HEALTH_SYSTEM_INFO, {
      pathParams: { healthSystemId },
      body: payload,
    });
    return response;
  }

  // added for partial info update, can be text or file of health system
  async updatePartialHealthSystemInformation(healthSystemId, payload) {
    const response = await API.patch(HEALTH_SYSTEM_INFO, {
      pathParams: { healthSystemId },
      body: payload
    });
    return response;
  }

  async getHospitalsForHealthSystem(queryParams) {
    const response = await API.get(HOSPITAL_LIST, {
      queryParams,
    });
    return response;
  }

  async createHospital(hospitalData) {
    const { health_system, ...hospitalCreateData } = hospitalData;
    const response = await API.post(CREATE_HOSPITAL, {
      body: hospitalCreateData,
      pathParams: { health_system },
    });
    return response;
  }

  async updateHospital(hospitalID, updatedhospitalData) {
    const response = await API.put(GET_HOSPITAL_DATA, {
      pathParams: { hospitalID },
      body: updatedhospitalData,
    });
    return response;
  }

  // added for partial info update, can be text or file of hospital
  async updatePartialHospitalInformation(hospitalID, payload) {
    const response = await API.patch(GET_HOSPITAL_DATA, {
      pathParams: { hospitalID },
      body: payload
    });
    return response;
  }


  async getSpecialtyOptions(queryParams) {
    const response = await API.get(GET_SPECIALTIES, {
      queryParams
    });
    return response.map(res => ({
      label: res.name,
      value: res.id ? res.id : res.name,
      id: res.id,
    }));
  }

  async createSpecialtyOption(optionName) {
    await new Promise((res, rej) => setTimeout(res, 3000));
    const newOption = {
      value: Date.now(),
      label: optionName,
    };
    this.specialtyOptions.push(newOption);
    return newOption;
  }

  async getInsuranceOptions() {
    const response = await API.get(INSURANCE_LIST);
    return response;
  }

  async createInsuranceOption(optionName) {
    await new Promise((res, rej) => setTimeout(res, 3000));
    const newOption = {
      value: Date.now(),
      label: optionName,
    };
    this.insuranceOptions.push(newOption);
    return newOption;
  }

  async getEHROptions() {
    const response = await API.get(EHR_LIST);
    return response;
  }

  async createEHROption(optionName) {
    await new Promise((res, rej) => setTimeout(res, 3000));
    const newOption = {
      value: Date.now(),
      label: optionName,
    };
    this.ehrOptions.push(newOption);
    return newOption;
  }

  async accountsList(filterParams) {
    const response = await API.get(ACCOUNTS_LIST, {
      queryParams: filterParams,
    });
    return response;
  }

  async getAccount(accountId) {
    const response = await API.get(GET_ACCOUNT, {
      pathParams: { accountId },
    });

    return response;
  }

  async getAccountBasedHospitals(accountId, queryParams) {
    const response = await API.get(GET_ACCOUNT_HOSPITALS, {
      pathParams: { accountId },
      queryParams,
    });

    return response;
  }

  async getAccountBasedDepartments(accountId,filterParams) {
    const response = await API.get(GET_ACCOUNT_DEPARTMENTS, {
      pathParams: { accountId },
      queryParams:filterParams
    });

    return response;
  }

  async getTeamStatistics(queryParam) {
    const response = await API.get(GET_ACCOUNT_TEAM_STATISTICS, {
      queryParams: queryParam,
    });

    return response;
  }

  async getAccountMembers(accountId, queryParam) {
    const response = await API.get(GET_ACCOUNT_MEMBERS, {
      queryParams: queryParam,
      pathParams: { accountId },
    });

    return response;
  }

  async searchAccount(queryParam) {
    const response = await API.get(ACCOUNTS_LIST, {
      queryParams: queryParam,
    });
    return response;
  }

  async deleteAccount(healthsystemId) {
    const response = await API.delete(DELETE_ACCOUNT, {
      pathParams: { healthsystemId },
    });
    return response;
  }

  //DEPARTMENT

  async deleteDepartment(departmentId) {
    const response = await API.delete(DEPARTMENT, {
      pathParams: { departmentId },
    });
    return response;
  }

  async updateDepartment(departmentId, payload) {
    const response = await API.put(DEPARTMENT, {
      pathParams: { departmentId },
      body: payload,
    });
    return response;
  }

  async updatePartialDepartmentInformation(departmentId, payload) {
    const response = await API.patch(DEPARTMENT, {
      pathParams: {departmentId},
      body: payload
    });
    return response;
  }

  async getDepartment(departmentId) {
    const response = await API.get(DEPARTMENT, {
      pathParams: { departmentId },
    });
    return response;
  }

  async getDepartments(queryParams) {
    const response = await API.get(ALL_DEPARTMENT, {
      queryParams,
    });
    return response;
  }

  async createDepartment(hospitalId, payload) {
    const response = await API.post(CREATE_DEPARTMENT, {
      pathParams: { hospitalId },
      body: payload,
    });
    return response;
  }

  async getHospital(hospitalId) {
    const response = await API.get(HOSPITAL, {
      pathParams: { hospitalId },
    });
    return response;
  }

  async deleteHospital(hospitalId) {
    const response = await API.delete(HOSPITAL, {
      pathParams: { hospitalId },
    });
    return response;
  }

  async getDepartmentDropdown(hospitalId, queryParams = {}) {
    const response = await API.get(GET_DEPARTMENT_DROPDOWN, {
      pathParams: { hospitalId },
      queryParams
    });
    return response;
  }
  async createHealthSystem(payload) {
    const response = await API.post(CREATE_HEALTH_SYSTEM, {
      body: payload,
    });
    return response;
  }

  async getProviderEmail(keyword) {
    const response = await API.get(GET_PROVIDER_LIST, {
      queryParams: { search: keyword },
    });
    return response;
  }

  async createProvider(departmentID, providerBody) {
    const response = await API.post(CREATE_PROVIDER, {
      pathParams: { departmentID },
      body: providerBody,
    });
    return response;
  }

  async moodleAccountCreate(moodleData) {
    const response = await API.post(MOODLE_ACTION, {
      body: moodleData,
    });
    return response;
  }

  async moodleAccountUpdate(providerId, providerBody) {
    const response = await API.put(MOODLE_ACTION_MODIFY, {
      pathParams: { providerId },
      body: providerBody,
    });
    return response;
  }

  async moodleAccountDelete(providerId) {
    const response = await API.delete(MOODLE_ACTION_MODIFY, {
      pathParams: { providerId },
    });
    return response;
  }

  async syncProvidersWithMoodle(departmentId) {
    const response = await API.get(MOODLE_SYNC_PROVIDER_BY_DEPARTMENT, {
      pathParams: { departmentID: departmentId },
    });
    return response;
  }
  
  async getProvidersByDeparment(departmentID, queryParams) {
    const response = await API.get(GET_PROVIDER_BY_DEPARTMENT, {
      pathParams: { departmentID },
      queryParams
    });
    return response;
  }
  async getProvider(providerId) {
    const response = await API.get(GET_PROVIDER, {
      pathParams: { providerId },
    });
    return response;
  }
  async onProviderUpdate(providerId, providerBody) {
    const response = await API.put(UPDATE_PROVIDER, {
      pathParams: { providerId },
      body: providerBody,
    });
    return response;
  }

  async updatePartialProviderInformation(providerId, payload) {
    const response = await API.patch(UPDATE_PROVIDER, {
      pathParams: { providerId },
      body: payload
    })
    return response
  }

  async onDeleteProvider(providerId) {
    const response = await API.delete(DELETE_PROVIDER, {
      pathParams: { providerId },
    });
    return response;
  }

  async healthSystemNamesAndPrefix() {
    const response = await API.get(HEALTH_SYSTEM_VALIDATION);
    return response;
  }

  async cqUsersMailId() {
    const response = await API.get(CQ_USERS_MAIL_ID);
    return response;
  }

  async cqHospitalsData() {
    const response = await API.get(CQ_HOSPITAL_DATA);
    return response;
  }

  async getHospitalDepartments(queryParams) {
    const response = await API.get(HOSPITAL_DEPARTMENTS, {
      pathParams: { hospitalId: queryParams?.hospital_id },
      queryParams,
    });
    return response;
  }

  async getPhysicians(queryParams) {
    const response = await API.get(PHYSICIAN_LIST, {
      queryParams,
    });
    return response;
  }

  async getClientSpocList(queryParams) {
    const response = await API.get(GET_CLIENT_SPOC_LIST, {
      queryParams
    });
    return response;
  }

  async getCMSDataCount(queryParams) {
    const response = await API.get(CMS_DATA_COUNT, {
      queryParams
    });
    return response;
  }

  async getSpecVisitsPerProvPercentile(queryParams) {
    const response = await API.get(SPEC_VISITS_PER_PROV_PERCENTILE, {
      queryParams
    });
    return response;
  }

  // returns the cms
  async getCMSSpecCount(queryParams) {
    const response = await API.get(CMS_SPEC_COUNT, {
      queryParams
    });
    return response;
  }

  async getQualifications() {
    const response = await API.get(QUALIFICATION);
    return response;
  }

  async createQualification(payload){
    const response = await API.post(QUALIFICATION, {
      body: payload,
    });
    return response;
  } 

  async qualificationToClient(providerId, payload){
    const response = await API.post(QUALIFICATION_TO_CLIENT, {
      pathParams: {providerId: providerId},
      body: {qualification_ids: payload},
    })
    return response;
  }

  // Get deletion preview
  async getAccountDeletionPreview(accountId) {
    const response = await API.get(HEALTH_SYSTEM_PERMANENT_DELETE, {
      pathParams: {accountId: accountId},
    })
    return response;
  }

  // Permanent delete with confirmation
  async permanentDeleteAccount(accountId, confirmationText) {
    const response = await API.post(HEALTH_SYSTEM_PERMANENT_DELETE, {
      pathParams: {accountId: accountId},
      body: {confirmation_text: confirmationText},
    })
    return response;
  }

  async archivedAccountsList(filterParams) {
    const response = await API.get(ACRHIVED_ACCOUNTS_LIST, {
      queryParams: filterParams,
    });
    return response;
  }

  async restoreAccount(healthsystemId) {
    const response = await API.post(RESTORE_ACCOUNT, {
      pathParams: { healthsystemId },
    });
    return response;
  }

}

const accountsRepository = new AccountsRepository();
export default accountsRepository;
